import request from '../axios';

export const getProvinces = async () => {
  const {data}: {data: Array<IProvince>} = await request.get(
    `/api/v2/base/state`,
  );
  return data;
};
